import React, { useContext } from "react"
import AppContext from "../../shared/AppContext"
import { Link } from "react-router-dom"
import { Redirect } from "react-router"
import "./aboutdrilldowns.scss"

const AboutDrillDowns = (props) => {
  const { openInquireModal, serviceType, trackEvent } = useContext(AppContext)

  if (!props.viewer || !props.viewer.isUserAuthenticated) {
    return (
      <Redirect
        to={{ pathname: "/login", state: { from: "/research/drill-downs" } }}
      />
    )
  }

  const renderLiveResultsButton = () => {
    const { roles } = props.viewer
    const hasAdminRoleOrDD = roles.some(
      (roles) =>
        roles === "DrillDowns" ||
        roles === "ETR Master Admin" ||
        roles === "ETR Research Admin" ||
        roles === "ETR Sales Admin"
    )

    if (!hasAdminRoleOrDD) {
      return (
        <button
          className="btn etr-button-blue-gradient"
          data-cy="cta-button"
          onClick={() => {
            trackEvent("Upgrade Today button clicked")
            openInquireModal(serviceType.UpgradePlan)
          }}
        >
          Upgrade Today
        </button>
      )
    }

    return (
      <Link
        className="btn etr-button-blue-gradient"
        data-cy="cta-button"
        onClick={() => trackEvent("Live Results button clicked")}
        to="drill-downs/macro-views-sep-21"
      >
        Live Results
      </Link>
    )
  }

  return (
    <main className="about-drill-downs-landing">
      <div className="page-content drill-downs-grid">
        <div className="row1">
          <h1 className="title-page">Drill Down Surveys</h1>
          <p className="about-drill-intro">
            ETR's Drill Down surveys are event, logic-triggered, or client
            commissioned studies with a targeted group of our IT decision makers
            database to understand the reasoning and driving factors behind
            trends shaping the enterprise technology landscape. Questions are
            relevant to the desired topic of the drill down survey, and are
            conducted in real-time to ensure maximum speed to market.
          </p>
          {renderLiveResultsButton()}
        </div>
        <div className="row2">
          <div className="about-drill-downs-how-it-works">
            <h2 className="image-title">How it works:</h2>
            <img
              className="how-it-works-image"
              src="/static/images/dd_how_it_works.png"
            />
          </div>
        </div>
        <div className="row3">
          <div className="example-container">
            <h2 className="image-title">Examples of this include:</h2>
            <img
              className="etr-driven-image"
              src="/static/images/dd_etr_driven.png"
            />
            <img
              className="client-driven-image"
              src="/static/images/dd_client_driven.png"
            />
          </div>
        </div>
      </div>

      <div className="about-footer">
        <div>
          <p>
            If you are interested in conducting your own Custom Survey, please
            contact your sales representative.
          </p>
        </div>
        <div className="contact-sales">
          <button
            className="btn etr-button-orange"
            data-cy="contact-sales-button"
            onClick={() => {
              trackEvent("Contact Sales button clicked")
              openInquireModal(serviceType.ConductAFlashSurvey)
            }}
          >
            Contact Sales
          </button>
        </div>
      </div>
    </main>
  )
}

export default AboutDrillDowns
